import React from 'react'

const SectionHeader_1 = (props) => {
    const {title, subTitle, text} = props;
    return (
        <div className='section-title-wrapper'>
            <div className="title-wrapper">
                {
                    title &&
                    <h2 className="section-title has_fade_anim text-gray-700 fs-4x ls-1 text-grad-1" style={{ transform: 'translate(0px, 0px)', opacity: 1 }}>
                        {title}
                    </h2>
                }
                {
                    subTitle && 
                    <div className="section-title has_fade_anim fw-bold fs-1 mt-2 lh-2 text-grad">
                        {subTitle}
                    </div>
                }
                {
                    text && 
                    <p className="fs-2 px-20 mt-8 text-grad-3" style={{ transform: 'translate(0px, 0px)', opacity: 1 }}>
                        {text}
                    </p>
                }
            </div>
        </div>
        
    )
}

export {SectionHeader_1}